import React from 'react';
import classNames from 'classnames/bind';
import { Text } from '@carnica/ui-kit';
import { IconLayersFilled, IconSpeedFilled } from '@carnica/graphics';
import { useIsMobileDimension } from '@carnica/utils/hooks';
import { getIsTariffAccumsFttbDivideEnabled } from '@beef/elk-common';
import styles from "./styles.pcss";
var cn = classNames.bind(styles);
var getIcon = function getIcon(item) {
  var _item$iconSrc;
  return (_item$iconSrc = item.iconSrc) !== null && _item$iconSrc !== void 0 && _item$iconSrc.includes('IconDataGroupFilled') ? /*#__PURE__*/React.createElement(IconLayersFilled, {
    color: "secondary",
    "data-t-id": "components-HomeServices"
  }) : /*#__PURE__*/React.createElement(IconSpeedFilled, {
    color: "secondary"
  });
};
export var HomeServices = function HomeServices(_ref) {
  var items = _ref.items;
  var isMobile = useIsMobileDimension();
  var isBlockDivideEnabled = getIsTariffAccumsFttbDivideEnabled();
  return /*#__PURE__*/React.createElement("div", {
    className: cn('container')
  }, items.map(function (item) {
    return /*#__PURE__*/React.createElement("div", {
      className: cn('item', {
        'item-extended': isBlockDivideEnabled
      }),
      key: item.value
    }, !isBlockDivideEnabled && getIcon(item), /*#__PURE__*/React.createElement("div", {
      className: cn({
        inline: isBlockDivideEnabled
      })
    }, /*#__PURE__*/React.createElement(Text, {
      variant: isMobile ? 'caption-medium' : 'body-paragraph-small'
    }, item.value), /*#__PURE__*/React.createElement(Text, {
      variant: isMobile ? 'caption-medium' : 'body-paragraph-small'
    }, item.unit.toLocaleLowerCase())));
  }));
};